export default { PENDING: 'pending', CANCEL: 'cancel' };
